/* Filtr klientů podle nefinančního majetku.
 *
 * ZADÁNÍ VLASTNÍKA (7. 8. 2026): „Vyplním analýzu, vím, že klient má firmu,
 * dědictví, auto, baráky — pak můžu filtrovat klienty podle nefinančního
 * majetku."
 *
 * ODKUD SE BEROU DATA:
 * `/api/crm/contacts` vrací u každého kontaktu `asset_kinds` — pole druhů
 * majetku (nemovitost / pozemek / vozidlo / cennosti / firma / dedictvi /
 * ostatni), odvozené z kolekce `assets`. Seznam klientů se načítá jedním
 * dotazem bez parametrů a filtruje se v JS, proto druhy jezdí rovnou
 * v odpovědi. Částky v seznamu klientů NEJSOU a nemají tam co dělat.
 *
 * NEZNÁMÉ ≠ PRÁZDNÉ:
 * Klient BEZ `asset_kinds` znamená „majetek neevidujeme", ne „majetek nemá".
 * Filtr ho proto při aktivním výběru jen neukáže — nikdy o něm netvrdí, že
 * je bez majetku.
 *
 * Čisté funkce, žádný React.
 */

/* Barva druhu majetku. Sdílená mezi filtrem a záložkou Majetek ve složce —
 * kdyby si každý držel vlastní paletu, chip ve filtru by měl jinou barvu než
 * karta ve složce a poradce by je nespojil. */
export const BARVA_DRUHU = {
  nemovitost: "#C25934",
  pozemek: "#5B8C51",
  vozidlo: "#3E6B8F",
  cennosti: "#B08A3E",
  firma: "#7A5A9E",
  dedictvi: "#A0705A",
  ostatni: "#8E8E93",
};

export const barvaDruhu = (druh) => BARVA_DRUHU[String(druh ?? "").trim()] || BARVA_DRUHU.ostatni;

/** Druhy majetku jednoho klienta — vždy pole, i když backend pošle nesmysl. */
export function druhyKlienta(c) {
  return Array.isArray(c?.asset_kinds) ? c.asset_kinds.filter((k) => typeof k === "string" && k) : [];
}

/**
 * Má klient VŠECHNY vybrané druhy majetku?
 *
 * AND schválně — stejně jako sousední filtr „Co má u mě". Poradce, který
 * klikne na nemovitost i firmu, hledá klienta, co má obojí; kdyby to bylo
 * NEBO, dostal by skoro celou databázi a filtr by k ničemu nebyl.
 */
export function maVsechnyDruhy(c, vybrane) {
  const chtene = vybrane instanceof Set ? vybrane : new Set(vybrane || []);
  if (!chtene.size) return true;
  const ma = new Set(druhyKlienta(c));
  for (const d of chtene) if (!ma.has(d)) return false;
  return true;
}

/** Klienti, kteří mají všechny vybrané druhy majetku. Prázdný výběr nefiltruje. */
export function filtrujPodleMajetku(contacts, vybrane) {
  const arr = Array.isArray(contacts) ? contacts : [];
  const chtene = vybrane instanceof Set ? vybrane : new Set(vybrane || []);
  if (!chtene.size) return arr;
  return arr.filter((c) => c && maVsechnyDruhy(c, chtene));
}
